import Blocks from '@component/Blocks';
import EntryIndex from '@component/EntryIndex';
import PageHeader from '@component/PageHeader';
import Box from '@componentPrimitives/Box';
import Container from '@componentPrimitives/Container';
import Grid from '@componentPrimitives/Grid';
import { EntryLinks } from '@components/PageHeader/EntryLinks';
import { useTranslations } from 'next-intl';

const ArticleIndex = () => {
  const t = useTranslations();

  return (
    <>
      <PageHeader />
      <EntryIndex indexKey="articleIndex">
        <Box paper cx={{ pB: 'xl' }}>
          <Container cx={{ pB: 'lg' }}>
            <Grid cx={{ mB: 'xl' }}>
              <Grid.Col sm={6}>
                <EntryLinks />
              </Grid.Col>
              <Grid.Col sm={6} cx={{ textAlign: 'right' }}>
                <EntryIndex.Filters
                  items={[
                    {
                      categoryTypeId: 'articleCategory',
                      label: t('articleCategory.singularName'),
                    },
                  ]}
                />
              </Grid.Col>
              <Grid.Col>
                <EntryIndex.CategoryChips />
              </Grid.Col>
            </Grid>
          </Container>
          <Container>
            <EntryIndex.ScrollTop />
            <EntryIndex.Grid />
            <EntryIndex.Pagination />
          </Container>
        </Box>
      </EntryIndex>
      <Blocks />
    </>
  );
};

export default ArticleIndex;
